export default function ({ store, redirect, route }) {
    if (!store.getters.fullservePlus && !store.getters.canAgent) {
        return redirect('/survey')
    }
}
